import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {MessageService} from 'primeng/api';
import {InvoiceAndSoaService} from '../../@shared/new-services/invoice-and-soa.service';
import {UserMgmtService} from '../../@shared/new-services/user-mgmt.service';
import {CacheService} from '../../@shared/services/cache.service';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'invoice-filters',
    templateUrl: './invoice-filters.component.html',
    styleUrls: ['./invoice-filters.component.scss']
})
export class InvoiceFiltersComponent implements OnInit {

    @Input() clearFilterForm = false;
    @Output() emitFilterValue: EventEmitter<any> = new EventEmitter<any>();
    displayDetailedFilter = false;
    invoiceFilterForm: FormGroup;
    shipmentTypes: any;
    isLoading = false;
    customers: any[] = [];
    loggedInUser = this.cacheService.retrieveParsedResponse('detailedLoggedInUser');
    isAdmin = false;

    constructor(private invoiceAndSoaService: InvoiceAndSoaService, private messageService: MessageService,
                private userMgmtService: UserMgmtService, private cacheService: CacheService) {

    }

    ngOnInit(): void {
        this.createInvoiceFilterForm();
        this.getShipmentTypes();
        this.getEntitiesByUser();
        this.loggedInUser?.roles?.map((role) => {
            if (role?.roleId === environment.portalAdminRoleId || role?.roleId === environment.ffAdminRoleId) {
                this.isAdmin = true;
            }
        });
    }

    ngOnChanges() {
        if (this.clearFilterForm) {
            this.createInvoiceFilterForm();
        }
    }

    onSearchOfInvoiceNumber() {
        this.invoiceFilterForm.patchValue({
            customerReferenceNumber: null,
            bookingId: null,
            orderTypes: null,
            fromDate: null,
            toDate: null,
            transportNumber: null,
        });
        const invoiceFilterValue = this.invoiceFilterForm.value;
        this.emitFilterValue.emit({
            invoiceFilterValue
        });
    }

    onSubmitInvoiceFilterForm(event: Event, from?: any) {
        if (from === 'job-types') {
            event?.preventDefault();
        }
        this.invoiceFilterForm.controls.filterByIdentifier.setValue(null);
        const invoiceFilterValue = this.invoiceFilterForm.value;
        this.emitFilterValue.emit({
            invoiceFilterValue
        });
        this.displayDetailedFilter = false;
    }

    resetBookingFilterForm() {
        this.createInvoiceFilterForm();
        this.emitFilterValue.emit({
            action: 'reset'
        });
        this.displayDetailedFilter = false;
    }

    getShipmentTypes() {
        this.isLoading = true;
        this.invoiceAndSoaService
            .getShipmentTypes()
            .subscribe(
                (x) => {
                    this.isLoading = false;
                    this.shipmentTypes = x;
                }, error => {
                    this.isLoading = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Job Types Error !',
                        detail: error?.message ? error?.message : error,
                        key: 'error-invoice-filter'
                    });
                }
            );
    }

    createInvoiceFilterForm() {
        this.invoiceFilterForm = new FormGroup({
            filterByIdentifier: new FormControl(),
            customerReferenceNumber: new FormControl(),
            bookingId: new FormControl(),
            orderTypes: new FormControl([]),
            fromDate: new FormControl(),
            toDate: new FormControl(),
            businessEntityId: new FormControl(),
            transportDocument: new FormControl(),
        });
    }

    applyCustomerFilter() {
        const invoiceFilterValue = this.invoiceFilterForm.value;
        if (invoiceFilterValue?.businessEntityId === null) {
            invoiceFilterValue.businessEntityId = '';
        }
        this.emitFilterValue.emit({
            invoiceFilterValue
        });
    }

    getEntitiesByUser() {
        this.userMgmtService
            .getEntitiesByUser()
            .subscribe((entities: any) => {
                this.customers = entities;
            });
    }

    onInputOfIdentifierValue(from: string) {
        if (from === 'booking-id') {
            this.invoiceFilterForm.controls.customerReferenceNumber.setValue(null);
            this.invoiceFilterForm.controls.transportDocument.setValue(null);
        }

        if (from === 'transport-document') {
            this.invoiceFilterForm.controls.customerReferenceNumber.setValue(null);
            this.invoiceFilterForm.controls.bookingId.setValue(null);
        }

        if (from === 'customer-ref-number') {
            this.invoiceFilterForm.controls.transportDocument.setValue(null);
            this.invoiceFilterForm.controls.bookingId.setValue(null);
        }
        this.invoiceFilterForm.controls.fromDate.setValue(null);
        this.invoiceFilterForm.controls.toDate.setValue(null);
        this.invoiceFilterForm.controls.orderTypes.setValue([]);
    }
}
